export const BUSINESS_DEBIT_CARD = 'business_debit_card';
